var map = {
	"./background/homepage_background_1.png": 8212,
	"./background/homepage_background_1_reflected.png": 5494,
	"./booking_btn_en.png": 9211,
	"./booking_btn_zh.png": 3062,
	"./btn_background.png": 3656,
	"./fb.png": 9219,
	"./homepage_image.png": 4341,
	"./instagram.png": 9419,
	"./logo.png": 6338,
	"./logo_with_desc.png": 5061,
	"./logo_with_desc_en.png": 6279,
	"./lunch_menu_en.png": 6951,
	"./lunch_menu_zh.png": 2097,
	"./menuLogo1-5.png": 4872,
	"./menuLogo1.png": 3265,
	"./menuLogo2.png": 9954,
	"./mobile/cow_name_plate.png": 5462,
	"./mobile/menuBtn.png": 2645,
	"./mobile/nav_btn_background.png": 8318,
	"./mobile/profile.png": 8510,
	"./mobile/section1_background.png": 9944,
	"./mobile/section2_1.png": 3881,
	"./mobile/section3_t1_en.png": 9781,
	"./mobile/section3_t1_zh.png": 3770,
	"./nav_menu_background.png": 6790,
	"./page1/brown_banner.png": 1007,
	"./page1/brown_underline.png": 5586,
	"./page1/divider.png": 8999,
	"./page1/more_btn_en.png": 3842,
	"./page1/more_btn_en_2.png": 835,
	"./page1/section10/background.png": 1762,
	"./page1/section11/hk_shop_1.png": 4666,
	"./page1/section11/hk_shop_2.png": 1855,
	"./page1/section11/hk_shop_3.png": 5046,
	"./page1/section2/farm1.png": 4403,
	"./page1/section2/farm2.png": 6632,
	"./page1/section2/image.png": 9922,
	"./page1/section2/pork1.png": 5561,
	"./page1/section3/background.png": 7250,
	"./page1/section3/cow_section.png": 7353,
	"./page1/section3/header.png": 5246,
	"./page1/section3/header_en.png": 2297,
	"./page1/section3/placeholder.png": 1466,
	"./page1/section3/pork1.png": 3941,
	"./page1/section3/rare_tag.png": 3573,
	"./page1/section4/background_banner.png": 7675,
	"./page1/section4/btn_background.png": 3507,
	"./page1/section4/text.png": 2445,
	"./page1/section4/text_en.png": 5860,
	"./page1/section6/btn_page2.png": 1313,
	"./page1/section6/cow_name_plate.png": 3762,
	"./page1/section6/text_desc_background.png": 7922,
	"./page1/section7/background.png": 7394,
	"./page1/section7/text.png": 7186,
	"./page1/section7/text_en.png": 452,
	"./page1/section8/btn_page2.png": 925,
	"./page1/section9/background.png": 5370,
	"./page1/section9/header.png": 5742,
	"./page1/section9/header_en.png": 5684,
	"./page2/fb.png": 4476,
	"./page2/ig.png": 8085,
	"./page2/menuBanner.png": 364,
	"./page2/menuBirthdayButton_en.png": 7101,
	"./page2/menuBirthdayButton_zh.png": 2906,
	"./page2/menuBookButton.png": 7371,
	"./page2/menuLogo_en.png": 6964,
	"./page2/menuLogo_zh.png": 192,
	"./page2/whiteBanner.png": 755,
	"./whatsapp.png": 7690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;